import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { push } from "react-router-redux";
import parse from "url-parse";
import _ from "underscore";
//actions
import { actions } from "actions/resources";
import { searchProfiles } from "actions/search";
//antd
import { Col, Dropdown, Icon, Input, Menu, Table, Row, Button } from "antd";
//utils
import ProgressiveImage from "react-progressive-image";
import defaultProfileImage from "images/default_profile.jpg";
import moment from "moment";

export class StudentsList extends Component {
  state = {
    selectedCompany: null,
    selectedCompanyInfo: null,
    addEditFormVisible: false,
    infoFormVisible: false
  };

  componentWillMount() {
    this._fetchDependencies();
  }

  componentWillReceiveProps(nextProps) {
    const { fetchProfiles, studentsAlgolia } = this.props;
    if (
      nextProps &&
      nextProps.studentsAlgolia.length &&
      nextProps.studentsAlgolia !== studentsAlgolia
    ) {
      fetchProfiles({ id: _.pluck(nextProps.studentsAlgolia, "id") });
    }
  }

  _fetchDependencies = async () => {
    const { studentsAlgolia, searchProfiles } = this.props;

    console.log(this.props);
    if (!studentsAlgolia.length) {
      searchProfiles();
    }
  };

  _addStudent = async (recordId) => {

    const { handleAddStudent } = this.props;
    handleAddStudent(recordId);
    //   const {
    //     fetchProfiles,
    //     studentsAlgolia,
    //     updateProfile,
    //     updateUser
    //   } = this.props;

    //   const profile = await updateProfile(recordId, {
    //     status: recordStatus
    //   });
    //   await updateUser(profile.payload.user_id, {
    //     deactivated: recordStatus === "deactivated" ? true : false
    //   });
    //   return fetchProfiles({ id: _.pluck(studentsAlgolia.hits, "id") });
  };

  _onSearchInput = e => {
    const { searchProfiles } = this.props;
    searchProfiles(e.target.value);
  };

  _recordStatus = (id, status) => {
    const { profiles } = this.props;
    let profile = _.findWhere(profiles, { id: id });

    if (profile) {
      return profile.status;
    }

    return status;
  };

  render() {
    const { redirect, studentsAlgolia, handleAddStudent } = this.props;
    const Search = Input.Search;
    const columns = [
      {
        align: "center",
        width: 60,
        render: (text, record, e) => {
          let profileImage = record.image || defaultProfileImage;
          if (parse(record.image).host === "www.wesolv.co") {
            profileImage = `https://legacy.wesolv.co${parse(record.image).pathname
              }`;
          }
          return (
            <div>
              <ProgressiveImage
                src={profileImage}
                placeholder={defaultProfileImage}
              >
                {src => (
                  <div
                    alt="profile"
                    src={src}
                    style={{
                      backgroundPosition: "center",
                      backgroundImage: `url(${src})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      height: "0px",
                      width: "40px",
                      borderRadius: "50%",
                      paddingTop: "40px"
                    }}
                  />
                )}
              </ProgressiveImage>
            </div>
          );
        }
      },
      {
        width: 150,
        title: "First Name",
        dataIndex: "first_name",
        key: "first_name",
        align: "center",
        sorter: (a, b) => {
          return a.first_name
            .toLowerCase()
            .localeCompare(b.first_name.toLowerCase());
        }
      },
      {
        width: 150,
        title: "Last Name",
        dataIndex: "last_name",
        key: "last_name",
        align: "center",
        sorter: (a, b) => {
          return a.last_name
            .toLowerCase()
            .localeCompare(b.last_name.toLowerCase());
        }
      },
      {
        width: 300,
        title: "Email",
        dataIndex: "email",
        key: "email",
        align: "center",
        sorter: (a, b) => {
          return a.email.toLowerCase().localeCompare(b.email.toLowerCase());
        }
      },

      {
        width: 150,
        title: "Add",
        align: "center",
        dataIndex: "status",
        key: "status",
        sorter: (a, b) => {
          return a.status.toLowerCase().localeCompare(b.status.toLowerCase());
        },
        render: (text, record, e) => {
          return (
            <Button type="primary" onClick={() =>
              this._addStudent(record.user_id)
            }>
              Add
            </Button>
          );
        }
      }
    ];

    return (
      <div>
        <Row>
          <Col type="flex" justify="center" align="middle">
            <Search
              placeholder="Search WeSolvers"
              onChange={this._onSearchInput}
            />
          </Col>
        </Row>
        <br />
        <Row justify="center" align="middle">
          <Table
            columns={columns}
            dataSource={studentsAlgolia.hits}
            rowKey="name"
            size="small"
            scroll={{ x: 600 }}
          />
        </Row>
      </div>
    );
  }
}

export default connect(
  state => ({
    students: state.resources.collection.profile || [],
    profile: state.resources.detail.profile,
    profiles: state.resources.collection.profile,
    studentsAlgolia: state.search.studentsAlgolia
  }),
  dispatch => ({
    fetchProfiles: bindActionCreators(actions.fetchProfiles, dispatch),
    fetchProfile: bindActionCreators(actions.fetchProfile, dispatch),
    updateProfile: bindActionCreators(actions.patchProfile, dispatch),
    updateUser: bindActionCreators(actions.patchUser, dispatch),
    searchProfiles: bindActionCreators(searchProfiles, dispatch)
  })
)(StudentsList);



// WEBPACK FOOTER //
// ./src/components/dashboard/student/list.js